<form #editLocationForm="ngForm" name="form">
  <div mat-dialog-content>
    <div class="form-row align-items-center">
      <div class="col-4 my-1">
        <h6>Location name</h6>
        <input class="form-control" placeholder="Location name" name="locationName" #locationName="ngModel"
          [(ngModel)]="editLocation.Title" required>
      </div>

      <div class="col-4 my-1 ml-2">
        <h6>Category</h6>
        <mat-select name="categoryId" [placeholder]="categories?.length ? 'Uncategorized' : 'Select a category'"
          [(ngModel)]="editLocation.CategoryId" [disableOptionCentering]="true" panelClass="mat-location-select">
            <mat-option selected *ngIf="categories?.length; else noCategories" [value]="null">Uncategorized</mat-option>
            <ng-template #noCategories>
              <mat-option disabled>There are no categories in the system</mat-option>
            </ng-template>
            <mat-option *ngFor="let category of categories"
              [value]="category.Id">{{ category.Name }}</mat-option>
        </mat-select>
      </div>

      <div class="col-3 text-right ml-auto my-1 align-self-end">
        <button mat-raised-button matTooltip="Cancel" class="w-40" [mat-dialog-close]="false">Cancel</button>
        <button mat-raised-button matTooltip="Save" class="ml-2 w-50 btn-green"
          [disabled]="!editLocationForm.valid || !(valueChanged | async)" [mat-dialog-close]="editLocation">Save</button>
      </div>
    </div>
  </div>
</form>
